<template>
    <card class="mt-6">
        <div ref="wrap" class="card-body mt-6">
            <div class="text-thin">
                <div v-if="!expired">
                    Reserved for <timer @expired="handleExpired" />
                </div>

                <div v-else class="text-red flex items-center justify-center">
                    <img class="inline mr-2" src="../../../assets/images/exclamation-mark.svg" alt="" width="17" height="17" />
                    Your slot is no longer reserved.
                </div>
            </div>

            <button v-if="!expired"
                    type="button"
                    role="button"
                    class="btn btn-secondary btn-xs"
                    :class="{ loading: cancellingReservedAppointment }"
                    @click.prevent="sendCancelReservedAppointmentRequest"
            >Change appointment</button>
        </div>
    </card>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    import Card from '../../Block/Card';
    import Timer from '../../Appointments/Timer';

    export default {
        name: 'reserved-countdown',

        components: {
            Card,
            Timer,
        },

        data() {
            return {
                expired: false,
            };
        },

        computed: {
            ...mapState('appointment', [
                'appointmentData',
            ]),

            ...mapState('appointments', [
                'cancellingReservedAppointment',
            ]),
        },

        mounted() {
            this.listen('appointment.refreshed', this.handleRefreshed);
        },

        destroyed() {
            this.silence('appointment.refreshed', this.handleRefreshed);
        },

        methods: {
            ...mapActions('appointments', [
                'cancelReservedAppointment',
            ]),

            sendCancelReservedAppointmentRequest() {
                const appointmentId = this.appointmentData.appointment.AppointmentID;

                const callback = () => this.$router.push({ name: 'home' });

                this.cancelReservedAppointment({ appointmentId, callback });
            },

            handleExpired() {
                this.expired = true;

                this.dispatch('appointment.expired');

                this.showModal('reserve-same-appointment');
            },

            handleRefreshed() {
                this.expired = false;
            },
        },
    }
</script>
